// extracted by mini-css-extract-plugin
export var accordionContent = "accordion-module--accordionContent--915f9";
export var accordionContentActive = "accordion-module--accordionContentActive--6696e";
export var accordionHandle = "accordion-module--accordionHandle--e32b4";
export var accordionItem = "accordion-module--accordionItem--b8e11";
export var accordionTitle = "accordion-module--accordionTitle--06f6a";
export var accordionTrigger = "accordion-module--accordionTrigger--ee71c";
export var accordionWrapper = "accordion-module--accordionWrapper--973cc";
export var focussedTrigger = "accordion-module--focussedTrigger--17755";
export var open = "accordion-module--open--657d7";
export var textAccordionBlock = "accordion-module--textAccordionBlock--1f713";